import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectVideoSenderScreenStream } from 'flow/selectors/video-selectors';
import TileStageScreenShare from './TileStageScreenShare';

/** The local user's shared screen on the stage. Resolves the local screen
 * stream (a raw MediaStream in the store) and hands it to the shared tile. No
 * presenter label — the "You are presenting" badge already names it. */
const TileLocalStageScreenShare: React.FC = () => {
    const senderScreenStream = useAppSelector(selectVideoSenderScreenStream);

    return (
        <TileStageScreenShare
            stream={senderScreenStream}
            sourceKey={senderScreenStream}
        />
    );
};

export default React.memo(TileLocalStageScreenShare);
